import React from 'react';

import { ReactComponent as AppSvg } from '../../assets/icons/app.svg';
import { ReactComponent as ChevronSvg } from '../../assets/icons/chevron.svg';
import { ReactComponent as DiscoverSvg } from '../../assets/icons/discover.svg';
import { ReactComponent as LogoSvg } from '../../assets/icons/logo.svg';
import { ReactComponent as MenuSvg } from '../../assets/icons/menu.svg';
import { ReactComponent as PlusSvg } from '../../assets/icons/plus.svg';
import { ReactComponent as ProfileSvg } from '../../assets/icons/profile.svg';
import { ReactComponent as SearchSvg } from '../../assets/icons/search.svg';
import { ReactComponent as SettingsSvg } from '../../assets/icons/settings.svg';
import { ReactComponent as WalletSvg } from '../../assets/icons/wallet.svg';
import { ReactComponent as WishlistsSvg } from '../../assets/icons/wishlists.svg';

import { Wrapper } from './styles';

const icons = {
    wishlists: <WishlistsSvg />,
    discover: <DiscoverSvg />,
    profile: <ProfileSvg />,
    chevron: <ChevronSvg />,
    settings: <SettingsSvg />,
    logo: <LogoSvg />,
    plus: <PlusSvg />,
    wallet: <WalletSvg />,
    search: <SearchSvg />,
    menu: <MenuSvg />,
    app: <AppSvg />,
};

export type IconsType = keyof typeof icons;

interface IconProps {
    name?: IconsType;
}

export const Icon = ({ name }: IconProps) => {
    if (!name) return null;

    return (
        <Wrapper aria-hidden $icon={name}>
            {icons[name]}
        </Wrapper>
    );
};
